<template>
  <Collapse simple class="collapse-warpper" value="1">
    <Panel name="1" class="collapse-panel">
      <span class="panel-title">{{initdata.title}}</span>
      <div slot="content">
        <!-- 复选框组 on-change 类似于watch-->
        <CheckboxGroup v-model="dataList" @on-change="oriChange">
          <drop
            class="sort-item"
            v-for="(item,index) in initdata.dataList"
            :data-index="index"
            :key="item.label"
            @eldrop="eldrop"
            :el-index="index"
          >
            <!-- 复选框 -->
            <Checkbox :label="index" class="sort-checkbox">
              <img :src="item.iconPath" class="sort-label-icon">
              <span class="sort-label">{{item.label}}</span>
            </Checkbox>
            <!-- 复选框人数 -->
            <span v-if="$route.name != 'userCitizen'" class="sort-number">{{item.number}}</span>
          </drop>
        </CheckboxGroup>
      </div>
    </Panel>
  </Collapse>
</template>

<script>
import drop from "../dragger/drop";
export default {
  created() {
    this.oriChange = this._.debounce(this._oriChange, this.debounceTime, false);
  },
  mounted() {},
  props: ["initdata", "filterListIndex",'debounceTime'],
  data() {
    return {
      dataList: []
    };
  },
  methods: {
    /* 复选组勾选装填改变 */
    _oriChange() {
      this.$emit("event", {
        fn: "oriChange",
        params: {
          selectedIndex: this.dataList,
          filterListIndex: this.filterListIndex
        }
      });
    },
    eldrop(e) {
      this.$emit("event", {
        fn: "oriDrop",
        params: {
          filterListIndex: this.filterListIndex,
          ...e
        }
      });
    },
    oriChange() {}, // 只是个空壳
    reset(){
      this.dataList = []
      this.$emit("event", {
        fn: "reset",
      })
    }
  },
  components: { drop }
};
</script>
<style scoped lang="less">
@import "./collapse.less";
.sort-label-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-left: 10px;
}
</style>
